export default "/images/ireview-dark.svg?9d49abe4c54e5a0e00bea233b45ee1f6";